export const links = {
  appStore: 'https://apps.apple.com/us/app/gopuff/id722804810',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.main.gopuff',
}
export const covidResponseLink = 'https://gopuff.com/go/covid-response'
